import { useEffect, useRef, useState } from 'react';
import storage from '../../../hooks/useStorage/useStorage';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

export const useHighlightsReadState = (highlightIds: string[]) => {
  const { team } = useApplicationContext();
  const userId = team?.userId ?? '';

  const [readIds, setReadIds] = useState<string[]>(() => storage.getReadHighlightIds(userId) ?? []);

  const currentIdsKey = highlightIds.join(',');

  useEffect(() => {
    if (!currentIdsKey) {
      return;
    }

    const currentIds = currentIdsKey.split(',');
    const stored = storage.getReadHighlightIds(userId) ?? [];
    const pruned = stored.filter((id) => currentIds.includes(id));

    if (pruned.length !== stored.length) {
      storage.setReadHighlightIds(pruned, userId);
    }

    setReadIds(pruned);
  }, [currentIdsKey, userId]);

  const readIdsRef = useRef(readIds);
  readIdsRef.current = readIds;

  const isRead = (highlightId: string) => readIds.includes(highlightId);

  const markAsRead = (highlightId: string) => {
    if (readIdsRef.current.includes(highlightId)) {
      return;
    }

    const next = [...readIdsRef.current, highlightId];

    readIdsRef.current = next;
    storage.setReadHighlightIds(next, userId);
    setReadIds(next);
  };

  return { isRead, markAsRead };
};
